// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__1U26A","content":"App_content__1A4-v"};